module.exports = __webpack_public_path__ + "img/kc1.bc297396.png";